module.exports = __webpack_public_path__ + "media/images/iconUp__inactive--dark-85a41490ab2a5274cc8c47623cc18b1c.png";